var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6778 27.9933L9.3445 28.006C6.41117 28.0086 4.00917 25.6113 4.00583 22.678L3.99317 9.34462C3.9905 6.41129 6.38783 4.00929 9.32117 4.00596L22.6545 3.99329C25.5878 3.99062 27.9898 6.38796 27.9932 9.32129L28.0058 22.6546C28.0092 25.5886 25.6112 27.9906 22.6778 27.9933Z",
    fill: "url(#paint0_radial_686_14785)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6778 27.9933L9.3445 28.006C6.41117 28.0086 4.00917 25.6113 4.00583 22.678L3.99317 9.34462C3.9905 6.41129 6.38783 4.00929 9.32117 4.00596L22.6545 3.99329C25.5878 3.99062 27.9898 6.38796 27.9932 9.32129L28.0058 22.6546C28.0092 25.5886 25.6112 27.9906 22.6778 27.9933Z",
    fill: "url(#paint1_radial_686_14785)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 20.6667C13.427 20.6667 11.333 18.5734 11.333 16C11.333 13.4267 13.427 11.3334 15.9997 11.3334C18.5723 11.3334 20.6663 13.4267 20.6663 16C20.6663 18.5734 18.5723 20.6667 15.9997 20.6667ZM15.9997 12.6667C14.1617 12.6667 12.6663 14.162 12.6663 16C12.6663 17.838 14.1617 19.3334 15.9997 19.3334C17.8377 19.3334 19.333 17.838 19.333 16C19.333 14.162 17.8377 12.6667 15.9997 12.6667Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12C21.5523 12 22 11.5523 22 11C22 10.4477 21.5523 10 21 10C20.4477 10 20 10.4477 20 11C20 11.5523 20.4477 12 21 12Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 24.6667H11.9997C9.42701 24.6667 7.33301 22.5734 7.33301 20V12C7.33301 9.42671 9.42701 7.33337 11.9997 7.33337H19.9997C22.5723 7.33337 24.6663 9.42671 24.6663 12V20C24.6663 22.5734 22.5723 24.6667 19.9997 24.6667ZM11.9997 8.66671C10.1617 8.66671 8.66634 10.162 8.66634 12V20C8.66634 21.838 10.1617 23.3334 11.9997 23.3334H19.9997C21.8377 23.3334 23.333 21.838 23.333 20V12C23.333 10.162 21.8377 8.66671 19.9997 8.66671H11.9997Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_686_14785",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.9198 28.0233) scale(29.9327 29.9327)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#FF543F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348,
    stopColor: "#FC5245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#E64771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#D53E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761,
    stopColor: "#CC39A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_686_14785",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.85717 3.69349) scale(19.8753 13.2429)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4168C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#4168C9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.52da82e86825390a9f71f3cdc8a5c850.svg";
export { ForwardRef as ReactComponent };